const Imagem = (DataBase, Datatype) => {
    const Imagem = DataBase.new({
        hash: Datatype.STRING,
        title: Datatype.STRING,
        thumb: Datatype.STRING,
        image: Datatype.STRING,
        mime_type: Datatype.STRING,
        type: Datatype.NUMBER,
    }, {
        auth: true,
        dateLogs: true,
        softDelete: false,
        collection: 'imagem',
        model: 'Imagem',
    });

    return Imagem;
}

export default Imagem;